// extracted by mini-css-extract-plugin
export default {"icon-cta":"IconCTA_icon-cta__fbxuk"};